module.exports = __webpack_public_path__ + "media/images/browsers/aol-explorer-e2cb4e5eccd5fbed1df98d3e401d7454.svg";